import { IConfig } from './models/config';

fetch('/api/config')
  .then((res) => res.json())
  .then((config: IConfig) => {
    (window as any).config = config;
  })
  .finally(() => {
    import('./realIndex');
  });
